/** Section headers for passthrough cost detail and PLI reconciliation sections. */
export const SECTION_HEADERS = {
    PASSTHROUGH_COST_DETAIL: "Passthrough Cost Detail",
    PLI_RECONCILIATION: "PLI Reconciliation",
    TOTAL_PASSTHROUGH_COST: "Total Passthrough Cost",
};

/** Column definitions for the Passthrough Cost Detail table. */
export const PASSTHROUGH_COLUMNS = {
    DATA_SOURCE_NAME: { id: "dataSourceName", header: "Data Source Name" },
    COMPANY: { id: "company", header: "Company" },
    GL_ACCOUNT_AND_SEGMENT: { id: "glAccountAndSegment", header: "GL Account + Segment Filter" },
    ORIGINAL_GL_BALANCE: { id: "originalGLBalance", header: "Original GL Balance" },
    MULTIPLIER: { id: "multiplier", header: "Multiplier" },
    PASSTHROUGH_CONTRIBUTION: { id: "passthroughContribution", header: "Passthrough Contribution" },
};

/** Column definitions for the PLI Reconciliation table. */
export const PLI_COLUMNS = {
    CHECK_NAME: { id: "checkName", header: "CHECK" },
    PNL_STATEMENT_AMOUNT: { id: "pnlStatementAmount", header: "P&L STATEMENT AMOUNT" },
    PLI_CALCULATION_AMOUNT: { id: "pliCalculationAmount", header: "PLI CALCULATION AMOUNT" },
    DELTA: { id: "delta", header: "DELTA" },
    STATUS: { id: "status", header: "STATUS" },
};

/** Status values used for reconciliation check comparison. */
export const RECONCILIATION_STATUS = {
    PASS: "Pass",
    FAIL: "Fail",
};

/** Tooltip titles used in passthrough cost detail cells. */
export const PASSTHROUGH_TOOLTIPS = {
    DATA_SOURCE_BADGE: "Data source set up in Step 2 of the calculation",
    SEGMENT_FILTER_LINK: "Includes COA mappings defined in the Custom COA table",
    CUSTOM_COA_REF_LINK: "Custom COA classification — click to view table",
};
